var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 fill-height",attrs:{"fluid":""}},[_c('iframe',{staticStyle:{"border":"none","min-height":"calc(100vh - 64px)"},attrs:{"src":_vm.url,"width":"100%","height":"100%","frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }